export const cubanBikeMarketData = [
    {
        title: "Electric bikes in Cuba",
        content: `
        In the mid 2020’s, a series of unexpected political changes ushered in a new era for Cuba,
        culminating in its transition to a democratic government. Years of increasing international
        pressure and internal dissent against the authoritarian regime led to a peaceful revolution, driven
        by a coalition of reformist leaders and civil society organizations. In a historic election, the Cuban
        people voted for a new democratic government that promised transparency, economic reform, and
        engagement with the global community. With this shift, the United States and Cuba restored
        diplomatic relations, leading to the lifting of trade embargoes that had been in place for over six
        decades.

        This newfound openness quickly transformed Cuba's economic landscape. As trade barriers
        were dismantled, American companies eagerly entered the Cuban market, bringing investments
        and technology that sparked rapid economic development. The Cuban government prioritized
        infrastructure improvements, focusing on modernizing its transportation network and enhancing
        connectivity across the island. This period of change opened numerous opportunities for both
        Cuban entrepreneurs and international businesses looking to establish a presence in the region,
        signaling a new chapter of economic collaboration and growth between Cuba and the United
        States.

        One major new program is called “Iniciativa Verde.” This project aims to rebuild the
        outdated transportation options on the island with new, environmentally friendly solutions.
        Funded by a broad public and private coalition, resources will be available to a select group of
        firms. You and your team have made it through the intense vetting process to be a part of the
        electric bike initiative! As a relatively low cost and highly versatile transportation option, electric
        bikes are growing in popularity around the world. No existing companies outside of this “pilot”
        will be allowed to access the e-bike market for three periods, so your team will have three periods
        to demonstrate success and establish a firm business on the island.
        `
    },
    {
        title: "Current Transportation Options in Cuba",
        content: `
        As Cuba embraces its new democratic identity and open trade policies, the transportation
        sector has undergone significant transformations to accommodate growing demand. Buses are
        currently the primary means of transportation in addition to a combination of vintage American
        cars, Soviet-era vehicles, motorcycles, and bikes. The public transportation system is strained
        with less than one bus for every 7,000 people, and 600,000 people need a means to travel each day.

        Furthermore, with the island’s natural beauty and cultural heritage attracting a surge of
        tourists, there is a growing emphasis on sustainable transport options that align with Cuba's
        environmental goals. This changing landscape sets the stage for innovative mobility solutions,
        such as electric bicycles, to play a significant role in Cuba's transportation future.
        `
    },
    {
        title: "Overview of the Electric Bicycle Market",
        content: `
        The global electric bicycle (e-bike) industry has experienced substantial growth in recent
        years, driven by increasing environmental awareness, rising fuel prices, and urban congestion.
        The market is projected to reach significant milestones, with estimates suggesting it could grow
        to $28.51 billion by 2027, at a compound annual growth rate (CAGR) of 7.9% from 2020 to
        2027. The industry's expansion is fueled by technological advancements, including improvements
        in battery life and motor efficiency, which have made e-bikes a more viable and attractive option
        for consumers seeking sustainable and cost-effective transportation solutions. The demand for e-
        bikes is particularly strong in urban areas, where they offer a practical solution to bypass traffic
        jams and reduce commute times.

        Asia holds the largest share of the global e-bike market, driven by high urbanization rates and
        supportive government policies. China, in particular, is a dominant player, accounting for 49.1%
        of the market share in 2020, thanks to its large population and robust manufacturing capabilities.
        Europe and North America are also significant markets, with increasing adoption driven by
        environmental concerns and the pursuit of healthier lifestyles. The industry faces challenges such
        as high retail prices due to the cost of advanced batteries and motor systems, and varying
        infrastructure and regulatory constraints across regions. However, the ongoing innovation and
        government initiatives promoting green transportation are expected to continue driving the
        growth of the global electric bicycle market in the coming years.

        An electric bike is a traditional bike frame that incorporates an electric motor and most
        commonly a rechargeable lithium-ion battery. The motor assists the rider in pedaling through
        user-controlled throttles on the handlebars and occasionally through sensors that detect rider
        effort.

        The electric bicycle (e-bike) market in Cuba is poised for rapid growth as the nation
        prioritizes sustainable transportation solutions. E-bikes, with their affordability, low
        environmental impact, and ability to navigate urban and rural terrains, present a massive
        opportunity across population types. A research study was commissioned to understand the
        probable market size and relative preferences of various populations within the country that
        would be most apt to purchase an electric bike.
        `
    },
];

